export const firebaseConfig = {
    apiKey: "AIzaSyC1iPIO3qFv7M1hQuKaF4MbS8-QBktXH2U",
    authDomain: "dxpress-flutter.firebaseapp.com",
    projectId: "dxpress-flutter",
    storageBucket: "dxpress-flutter.appspot.com",
    messagingSenderId: "358352890778",
    appId: "1:358352890778:web:64be5e01d67bc247d66823",
    measurementId: "G-BN9Y0MEHC7"
};